const init = () => {
    $(document).on('click', '.remove-toggle', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);
        $this.toggleClass('is-active');
        $this.parent().toggleClass('is-removed');
        $this.blur();
    });
}

export default init;